export default __webpack_public_path__ + "static/media/browser.51e22abd.png";